import React, { useContext } from 'react';

import { CompanyContext } from 'common/containers/CompanyContainer';
import { useOnboardingContext } from 'common/containers/OnboardingContainer';
import { cn } from 'common/style/utils';
import { onboardingManager } from 'common/subdomain/admin/AdminOnboarding/InAppOnboarding/OnboardingManager';

const OnboardingProgressIndicator = ({ className }: { className?: string }) => {
  const company = useContext(CompanyContext);
  const { onboarding } = useOnboardingContext();

  const hasUnCompletedSteps = onboardingManager.hasUnCompletedSteps(company, onboarding);

  if (!hasUnCompletedSteps) {
    return null;
  }

  return (
    <div className={cn('absolute size-2 rounded-full right-1.5 top-1.5 bg-grass-90', className)} />
  );
};

export default OnboardingProgressIndicator;
